<template>
  <div>
    <!-- Header -->
    <div class="header py-7 py-lg-8 pt-lg-9">
      <b-container>
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white">Bienvenido!</h1>
              <p class="text-lead text-white">Accede a información actualizada en tiempo real sobre tus operativos y mantente al día con los últimos acontecimientos.</p>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
             xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <b-card no-body class="bg-secondary border-0 mb-0">
            <!-- <b-card-header class="bg-transparent pb-5"  >
              <div class="text-muted text-center mt-2 mb-3"><small>Sign in with</small></div>
              <div class="btn-wrapper text-center">
                <a href="#" class="btn btn-neutral btn-icon">
                  <span class="btn-inner--icon"><img src="img/icons/common/github.svg"></span>
                  <span class="btn-inner--text">Github</span>
                </a>
                <a href="#" class="btn btn-neutral btn-icon">
                  <span class="btn-inner--icon"><img src="img/icons/common/google.svg"></span>
                  <span class="btn-inner--text">Google</span>
                </a>
              </div>
            </b-card-header> -->
            <b-card-body class="px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <small>Ingresa tus credenciales</small>
              </div>
              <b-form role="form" @submit.prevent="login">
                  <base-input alternative
                              class="mb-3"
                              prepend-icon="ni ni-email-83"
                              placeholder="Email"
                              name="Email"
                              :rules="{required: true, email: true}"
                              v-model="email">
                  </base-input>

                  <base-input alternative
                              class="mb-3"
                              prepend-icon="ni ni-lock-circle-open"
                              placeholder="Contraseña"
                              type="password"
                              name="Password"
                              :rules="{required: true, min: 6}"
                              v-model="password">
                  </base-input>
                  <!-- <div class="text-muted font-italic"><small>password strength: <span
                    class="text-success font-weight-700">strong</span></small></div> -->
                  <b-row class=" my-4">
                    <b-col cols="12">
                      <!-- <base-input :rules="{ required: { allowFalse: false } }" name=Privacy Policy>
                        <b-form-checkbox v-model="model.agree">
                          <span class="text-muted">I agree with the <a href="#!">Privacy Policy</a></span>
                        </b-form-checkbox>
                      </base-input> -->
                    </b-col>
                  </b-row>
                  <div class="text-center">
                    <b-button type="submit" variant="primary" class="mt-4">Iniciar Sesión</b-button>
                  </div>
                </b-form>
              <!-- <form @submit.prevent="login">
      <input v-model="email" type="text" placeholder="Usuario" required>
      <input v-model="password" type="password" placeholder="Contraseña" required>
      <button type="submit">Iniciar sesión</button>
    </form> -->
            </b-card-body>
          </b-card>
          <b-row class="mt-3">
            <b-col cols="6">
              <router-link to="/dashboard" class="text-light"><small>¿Olvidó su Contraseña?</small></router-link>
            </b-col>
            <b-col cols="6" class="text-right">
              <!-- <router-link to="/register" class="text-light"><small>Create new account</small></router-link> -->
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            email: '',
            password: ''
        };
    },
    methods: {
              login() {
          axios.post(process.env.VUE_APP_BACKEND_URL + '/login', {
              email: this.email,
              password: this.password
          }).then(response => {
              if (response.data.success) {
                  localStorage.setItem('userToken', response.data.token);
                  localStorage.setItem('userName', response.data.name); // Guardar el nombre del usuario
                  localStorage.setItem('userRole', response.data.role); // Guardar el rol del usuario

                  this.$router.push({ name: 'tables' });
              } else {
                  alert('Login fallido');
              }
          }).catch(error => {
              console.error('Error de autenticación:', error);
              alert('Error durante el inicio de sesión');
          });
        }

      }
};
</script>
<style>
</style>